module.exports = __webpack_public_path__ + "img/profile_teo_kk3.aa8c355f.jpg";